import { Component, type ErrorInfo, type ReactNode } from 'react';
import { emit } from '../postMessage';

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('ErrorBoundary caught', error, info);
    emit('error', {
      message: error.message,
      ...(error.stack !== undefined && { stack: error.stack }),
    });
  }

  override render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="flex h-full items-center justify-center p-8 text-center">
          <div>
            <h1 className="text-xl font-semibold">Something went wrong</h1>
            <p className="mt-2 text-sm opacity-70">{this.state.error.message}</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
